module.exports = __webpack_public_path__ + "img/dtgl.85a1b8c1.svg";